export enum SubscriptionChangeActionResult {
    confirmDowngrade = 1,
    confirmUpgrade = 2,
    cancelFuture = 3
}